import React, { useState, useEffect } from "react";
import "./Charty.css";
import { images } from "../../../assets";

function Charity({ categoryData }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(1); // Default number of visible items

  useEffect(() => {
    const updateVisibleItems = () => {
       // Update visible items based on window width
       const width = window.innerWidth;
       if (width <= 431) {
         setVisibleItems(1);
       } else if (width > 431 && width <= 821) {
         setVisibleItems(2);
       } else {
         setVisibleItems(3);
       }
    };

    // Call once to set initial visible items
    updateVisibleItems();

    // Add event listener to update visible items on window resize
    window.addEventListener("resize", updateVisibleItems);

    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % categoryData.length);
    }, 3000); // Adjust autoplay interval as needed

    return () => clearInterval(interval);
  }, [categoryData.length]);

  const goToPrevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + categoryData.length) % categoryData.length
    );
  };

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % categoryData.length);
  };

  const visibleItemsArray = [];
  for (let i = 0; i < visibleItems; i++) {
    visibleItemsArray.push(categoryData[(currentIndex + i) % categoryData.length]);
  }

  function formatNumber(numberString) {
    if (!numberString || typeof numberString !== 'string') return '';
    if (typeof numberString.replace !== 'function') return '';
  
    const number = Number(numberString.replace(/[₹,\s]/g, ""));
    if (isNaN(number)) return '';

    const suffixes = ["", " Thousand", " Million", " Billion", " Trillion"];
    const magnitude = Math.floor(Math.log10(number) / 3);
    const formattedNumber = Math.floor(number / Math.pow(10, magnitude * 3));
    return `${formattedNumber}${suffixes[magnitude]}+`;
  }

  return (
    <div className="charity">
      <div className="charityBox">
        <div className="charityTitle">Charity raised so far..</div>
        <div className="charityContent">
          <div className="carousel-inner">
            {categoryData.length > 0 &&
              visibleItemsArray.map((item, index) => {
                if(item&& item.cause_category_name){
                  return(
                <div className="card" key={index}>
                  <div className="cardinfo">
                    <div className="cardtitle">{item.cause_category_name}</div>
                    <div className="cardnumber">
                    ₹ {formatNumber(item.total_raised)}
                    </div>
                  </div>
                  <div className="cardphoto">
                    <img
                      src={item.category_image}
                      alt={item.cause_category_name}
                    />
                  </div>
                </div>
                  );
                }
                  else{
                    return null;
                  }
              })}
          </div>
          <div className="charitybutton">
            <button className="left" onClick={goToPrevSlide}>
              <img src={images.leftArrow} alt="Left Arrow" />
            </button>
            <button className="right" onClick={goToNextSlide}>
              <img src={images.rightArrow} alt="Right Arrow" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Charity;
